import { InjectionToken } from '@angular/core';

export const SYNC_CONFIGURATION_ROUTE_PREFIX = '/sync-configuration';

const BROWSER_ONLY_ROUTE_PREFIXES: readonly string[] = [
  SYNC_CONFIGURATION_ROUTE_PREFIX,
];

export function isBrowserOnlyPathname(pathname: string): boolean {
  return BROWSER_ONLY_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

export const IS_BROWSER_ONLY_ROUTE = new InjectionToken<boolean>(
  'IS_BROWSER_ONLY_ROUTE',
  {
    providedIn: 'root',
    factory: () =>
      typeof window !== 'undefined' &&
      isBrowserOnlyPathname(window.location.pathname),
  },
);
